import {
    getAccountDetail, removeAccount, addAccount, editAccount ,
    getRoleList, getRoleDetail, removeRole, addRole, editRole, getNotify
} from './account-data';

// Account
export const WAIT_INIT_ACCOUNT = "WAIT_INIT_ACCOUNT";

// Account Manager
export const GET_ACCOUNT_MANAGER_DETAIL = "GET_ACCOUNT_MANAGER_DETAIL";
export const GET_ACCOUNT_MANAGER_DETAIL_FAIL = "GET_ACCOUNT_MANAGER_DETAIL_FAIL";
export const GET_ACCOUNT_MANAGER_DETAIL_SUCCESS = "GET_ACCOUNT_MANAGER_DETAIL_SUCCESS";
export const SAVE_ACCOUNT_MANAGER_DETAIL = "SAVE_ACCOUNT_MANAGER_DETAIL";
export const SAVE_ACCOUNT_MANAGER_DETAIL_FAIL = "SAVE_ACCOUNT_MANAGER_DETAIL_FAIL";
export const SAVE_ACCOUNT_MANAGER_DETAIL_SUCCESS = "SAVE_ACCOUNT_MANAGER_DETAIL_SUCCESS";
export const DELETE_ACCOUNT_MANAGER_DETAIL = "DELETE_ACCOUNT_MANAGER_DETAIL";
export const DELETE_ACCOUNT_MANAGER_DETAIL_FAIL = "DELETE_ACCOUNT_MANAGER_DETAIL_FAIL";
export const DELETE_ACCOUNT_MANAGER_DETAIL_SUCCESS = "DELETE_ACCOUNT_MANAGER_DETAIL_SUCCESS";

// Account Role
export const GET_ACCOUNT_ROLE_LIST = "GET_ACCOUNT_ROLE_LIST";
export const GET_ACCOUNT_ROLE_LIST_FAIL = "GET_ACCOUNT_ROLE_LIST_FAIL";
export const GET_ACCOUNT_ROLE_LIST_SUCCESS = "GET_ACCOUNT_ROLE_LIST_SUCCESS";
export const GET_ACCOUNT_ROLE_DETAIL = "GET_ACCOUNT_ROLE_DETAIL";
export const GET_ACCOUNT_ROLE_DETAIL_FAIL = "GET_ACCOUNT_ROLE_DETAIL_FAIL";
export const GET_ACCOUNT_ROLE_DETAIL_SUCCESS = "GET_ACCOUNT_ROLE_DETAIL_SUCCESS";
export const SAVE_ACCOUNT_ROLE_DETAIL = "SAVE_ACCOUNT_ROLE_DETAIL";
export const SAVE_ACCOUNT_ROLE_DETAIL_FAIL = "SAVE_ACCOUNT_ROLE_DETAIL_FAIL";
export const SAVE_ACCOUNT_ROLE_DETAIL_SUCCESS = "SAVE_ACCOUNT_ROLE_DETAIL_SUCCESS";
export const DELETE_ACCOUNT_ROLE_DETAIL = "DELETE_ACCOUNT_ROLE_DETAIL";
export const DELETE_ACCOUNT_ROLE_DETAIL_FAIL = "DELETE_ACCOUNT_ROLE_DETAIL_FAIL";
export const DELETE_ACCOUNT_ROLE_DETAIL_SUCCESS = "DELETE_ACCOUNT_ROLE_DETAIL_SUCCESS";
export const CHANGE_ACCOUNT_ROLE_DETAIL = "CHANGE_ACCOUNT_ROLE_DETAIL";
export const GET_SITE_INIT = "GET_SITE_INIT";
export const GET_SITE_SUCCESS = "GET_SITE_SUCCESS";
export const GET_SITE_FAIL = "GET_SITE_FAIL";
export const GET_NOTIFY_INIT = "GET_NOTIFY_INIT";
export const GET_NOTIFY_FAIL = "GET_NOTIFY_FAIL";
export const GET_NOTIFY_SUCCESS = "GET_NOTIFY_SUCCESS";
export const REGET_NOTIFY_INIT = "REGET_NOTIFY_INIT";
export const REGET_NOTIFY_FAIL = "REGET_NOTIFY_FAIL";
export const REGET_NOTIFY_SUCCESS = "REGET_NOTIFY_SUCCESS";

export const loadAccountManagerDetail = (token, accountSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getAccountDetail(resolve, reject, token, accountSeq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_ACCOUNT_MANAGER_DETAIL_SUCCESS,
                params: {
                    accountDetail: data.accountDetail
                }
            });
        } else {
            dispatch({
                type: GET_ACCOUNT_MANAGER_DETAIL_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_ACCOUNT_MANAGER_DETAIL_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_ACCOUNT_MANAGER_DETAIL        
    });
}

export const saveAccountManagerDetail = (reqBodyObj, type, token) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            if (type === 'edit') {
                editAccount(resolve, reject, token, reqBodyObj);
            } else {
                addAccount(resolve, reject, token, reqBodyObj);
            }
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: SAVE_ACCOUNT_MANAGER_DETAIL_SUCCESS
                });
            } else {
                dispatch({
                    type: SAVE_ACCOUNT_MANAGER_DETAIL_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_ACCOUNT_MANAGER_DETAIL_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_ACCOUNT_MANAGER_DETAIL        
    });
}

export const doRemoveAccountManagerDetail = (seq, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        removeAccount(resolve, reject, token, seq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: DELETE_ACCOUNT_MANAGER_DETAIL_SUCCESS
            });
        } else {
            dispatch({
                type: DELETE_ACCOUNT_MANAGER_DETAIL_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_ACCOUNT_MANAGER_DETAIL_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: DELETE_ACCOUNT_MANAGER_DETAIL        
    });
}

export const loadAccountRoleList = (token, orgId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getRoleList(resolve, reject, token, orgId);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_ACCOUNT_ROLE_LIST_SUCCESS,
                params: {
                    roleList: data.data
                }
            });
        } else {
            dispatch({
                type: GET_ACCOUNT_ROLE_LIST_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_ACCOUNT_ROLE_LIST_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_ACCOUNT_ROLE_LIST        
    });
}

export const loadAccountRoleDetail = (token, seq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getRoleDetail(resolve, reject, token, seq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            let roleDetail = data.role ? data.role : {};
            roleDetail.auth = data.auth;

            dispatch({
                type: GET_ACCOUNT_ROLE_DETAIL_SUCCESS,
                params: {
                    roleDetail: roleDetail
                }
            });
        } else {
            dispatch({
                type: GET_ACCOUNT_ROLE_DETAIL_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_ACCOUNT_ROLE_DETAIL_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_ACCOUNT_ROLE_DETAIL        
    });
}

export const saveAccountRoleDetail = (reqBodyObj, type, token) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            if (type === 'edit') {
                editRole(resolve, reject, token, reqBodyObj);
            } else {
                addRole(resolve, reject, token, reqBodyObj);
            }
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: SAVE_ACCOUNT_ROLE_DETAIL_SUCCESS
                });
            } else {
                dispatch({
                    type: SAVE_ACCOUNT_ROLE_DETAIL_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_ACCOUNT_ROLE_DETAIL_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_ACCOUNT_ROLE_DETAIL        
    });
}

export const doRemoveAccountRoleDetail = (seq, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        removeRole(resolve, reject, token, seq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: DELETE_ACCOUNT_ROLE_DETAIL_SUCCESS
            });
        } else {
            dispatch({
                type: DELETE_ACCOUNT_ROLE_DETAIL_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_ACCOUNT_ROLE_DETAIL_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: DELETE_ACCOUNT_ROLE_DETAIL        
    });
}

export const changeRoleDetailAuth = (roleDetail, tableSeq, checked) => (dispatch) => {
    let auth = roleDetail.auth;
    for (let i = 0; i < auth; i++) {
        let tableInfo = auth[i];
        if (tableInfo.seq === tableSeq) {
            tableInfo.authLevel = checked ? 1 : 0;
        }
    }

    dispatch({
        type: CHANGE_ACCOUNT_ROLE_DETAIL,
        params: {
            roleDetail: roleDetail
        }
    });
}

export const doGetNotify = (site, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getNotify(resolve, reject, site, token);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            let notifyMsgRecord = data.notifyMsgRecord;
            
            dispatch({
                type: GET_NOTIFY_SUCCESS,
                params: {
                    notifyMsgRecord: notifyMsgRecord
                }
            });
        } else {
            dispatch({
                type: GET_NOTIFY_FAIL,
                params: {
                    notifyMsgRecord: null,
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_NOTIFY_FAIL,
            params: {
                notifyMsgRecord: null,
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_NOTIFY_INIT,
        params: {
            notifyMsgRecord: null,
            errMsg: null
        }
    });
}

export const reGetNotifyBySession = () => (dispatch) => {
    const loginParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN));
    const siteParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.SITE));
    let doPost = new Promise((resolve, reject) => {
        getNotify(resolve, reject, siteParams.selectSite, loginParams.authToken);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            let notifyMsgRecord = data.notifyMsgRecord;
            
            dispatch({
                type: REGET_NOTIFY_SUCCESS,
                params: {
                    notifyMsgRecord: notifyMsgRecord
                }
            });
        } else {
            dispatch({
                type: REGET_NOTIFY_FAIL,
                params: {
                    notifyMsgRecord: null,
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: REGET_NOTIFY_FAIL,
            params: {
                notifyMsgRecord: null,
                errMsg: err
            }
        });
    });

    dispatch({
        type: REGET_NOTIFY_INIT,
        params: {
            notifyMsgRecord: null,
            errMsg: null
        }
    });
}